import { render, staticRenderFns } from "./OrderInvoice.vue?vue&type=template&id=077c36f0&scoped=true&"
import script from "./OrderInvoice.vue?vue&type=script&lang=js&"
export * from "./OrderInvoice.vue?vue&type=script&lang=js&"
import style0 from "./OrderInvoice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderInvoice.vue?vue&type=style&index=1&id=077c36f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077c36f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VPagination,VSelect,VSimpleTable,VSpacer})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
